"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResult = exports.SearchBox = exports.searchComponents = void 0;

var lodash_1 = require("lodash");

var react_1 = __importStar(require("react"));

var fclasses_1 = require("@bodiless/fclasses");

var SearchContextProvider_1 = require("./SearchContextProvider");

var SearchInputBase = function SearchInputBase(props) {
  var _a = props.placeholder,
      placeholder = _a === void 0 ? 'Search' : _a,
      rest = __rest(props, ["placeholder"]);

  return react_1.default.createElement(fclasses_1.Input, __assign({}, rest, {
    placeholder: placeholder
  }));
};

exports.searchComponents = {
  SearchWrapper: fclasses_1.Div,
  SearchInput: SearchInputBase,
  SearchButton: fclasses_1.Button
};
var searchResultItemComponents = {
  ItemList: fclasses_1.Li,
  ItemH3: fclasses_1.H3,
  ItemAnchor: fclasses_1.A,
  ItemParagraph: fclasses_1.P
};

var SearchResultItemBase = function SearchResultItemBase(_a) {
  var components = _a.components,
      props = __rest(_a, ["components"]);

  var ItemList = components.ItemList,
      ItemH3 = components.ItemH3,
      ItemAnchor = components.ItemAnchor,
      ItemParagraph = components.ItemParagraph;
  var value = props.value;
  return react_1.default.createElement(ItemList, __assign({}, props), react_1.default.createElement(ItemH3, null, react_1.default.createElement(ItemAnchor, {
    href: value.link
  }, value.title)), react_1.default.createElement(ItemParagraph, null, value.preview));
};

var SearchResultItemClean = lodash_1.flow(fclasses_1.designable(searchResultItemComponents, 'SearchResultItem'))(SearchResultItemBase);
var searchResultComponents = {
  SearchResultWrapper: fclasses_1.Div,
  SearchResultList: fclasses_1.Ul,
  SearchResultListItem: SearchResultItemClean,
  SearchResultSummary: fclasses_1.P
};
var defaultResultCountMessage = 'Showing %count% result(s).';
var defaultResultEmptyMessage = 'No content matches your request, please enter new keywords.';

var SearchResultBase = function SearchResultBase(_a) {
  var components = _a.components,
      _b = _a.resultCountMessage,
      resultCountMessage = _b === void 0 ? defaultResultCountMessage : _b,
      _c = _a.resultEmptyMessage,
      resultEmptyMessage = _c === void 0 ? defaultResultEmptyMessage : _c;
  var searchResultContext = SearchContextProvider_1.useSearchResultContext();
  var SearchResultWrapper = components.SearchResultWrapper,
      SearchResultList = components.SearchResultList,
      SearchResultListItem = components.SearchResultListItem,
      SearchResultSummary = components.SearchResultSummary;
  var showResultCount = resultCountMessage.replace('%count%', searchResultContext.results.length.toString());

  if (!searchResultContext.results.length) {
    return react_1.default.createElement(SearchResultWrapper, null, react_1.default.createElement(SearchResultSummary, null, showResultCount), react_1.default.createElement(fclasses_1.H3, null, resultEmptyMessage));
  }

  return react_1.default.createElement(SearchResultWrapper, null, react_1.default.createElement(SearchResultSummary, null, showResultCount), react_1.default.createElement(SearchResultList, null, searchResultContext.results.map(function (item) {
    return react_1.default.createElement(SearchResultListItem, {
      key: item.id,
      value: item
    });
  })));
};

var SearchBoxBase = function SearchBoxBase(_a) {
  var components = _a.components,
      props = __rest(_a, ["components"]);

  var _b = react_1.useState(''),
      queryString = _b[0],
      setQueryString = _b[1];

  var searchResultContext = SearchContextProvider_1.useSearchResultContext();
  var searchPagePath = process.env.BODILESS_SEARCH_PAGE || 'search';
  var onChangeHandler = react_1.useCallback(function (event) {
    event.preventDefault();
    setQueryString(event.target.value);
  }, []);
  /**
   * When searchTerm updated, by click or enterkey, update queryString.
   * This is to sync search term in different searchInput components.
   */

  react_1.useEffect(function () {
    if (queryString !== searchResultContext.searchTerm) {
      setQueryString(searchResultContext.searchTerm);
    }
  }, [searchResultContext.searchTerm]);

  var searchLocationValidate = function searchLocationValidate() {
    if (searchPagePath !== window.location.pathname.replace(/^\//, '').replace(/\/$/, '')) {
      window.location.href = "/" + searchPagePath + "/#" + encodeURIComponent(queryString);
    }
  };

  var searchHandler = react_1.useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        searchLocationValidate();
        searchResultContext.setSearchTerm(queryString);
        return [2
        /*return*/
        ];
      });
    });
  }, [queryString]);
  var onKeyPressHandler = react_1.useCallback(function (event) {
    if (event.key === 'Enter') {
      searchHandler();
    }
  }, [queryString]);
  var onClickHandler = react_1.useCallback(function (event) {
    event.preventDefault();
    searchHandler();
  }, [queryString]);

  var _c = props.placeholder,
      placeholder = _c === void 0 ? 'Search' : _c,
      rest = __rest(props, ["placeholder"]);

  var SearchWrapper = components.SearchWrapper,
      SearchInput = components.SearchInput,
      SearchButton = components.SearchButton;
  return react_1.default.createElement(SearchWrapper, __assign({}, rest), react_1.default.createElement(SearchInput, {
    value: queryString,
    onChange: onChangeHandler,
    onKeyPress: onKeyPressHandler,
    placeholder: placeholder
  }), react_1.default.createElement(SearchButton, {
    onClick: onClickHandler
  }));
};

exports.SearchBox = fclasses_1.designable(exports.searchComponents, 'SearchBox')(SearchBoxBase);
exports.SearchResult = fclasses_1.designable(searchResultComponents, 'SearchResult')(SearchResultBase);